import { FETCH_VBQL_RESULT } from './vbqlResultsReducer';

export const execVBQL = (projectionKey, vbqlStatement) => ({
  type: FETCH_VBQL_RESULT,
  payload: {
    projectionKey,
    query: {
      vbqlStatement,
    },
  },
});

export const execFetchSchemaVBQL = (projectionKey) => ({
  type: FETCH_VBQL_RESULT,
  payload: {
    projectionKey,
    query: {
      vbqlStatement: 'DESCRIBE media',
    },
  },
});

export const execFetchFieldSampleVBQL = (projectionKey, fieldName) => ({
  type: FETCH_VBQL_RESULT,
  payload: {
    projectionKey,
    query: {
      vbqlStatement: `SELECT topN(1000, ${fieldName}) AS sample FROM media`,
    },
  },
});

export default {
  execVBQL,
  execFetchSchemaVBQL,
  execFetchFieldSampleVBQL,
};
